<template>
  <div>
    <van-popup v-model="detailModel"
               position="bottom"
               :style="{ height: '100%',background: '#f5f5f5' }">
      <van-nav-bar fixed>
        <div slot="title">审批明细</div>
        <div slot="right"
             @click="closeCur">关闭</div>
      </van-nav-bar>
      <div class="detail-con">
        <van-cell-group>
          <van-cell title="审批状态"
                    v-model="detail.DeclareStateName" />
          <van-cell title="课程名称"
                    v-model="detail.DeclareSujectName" />
          <van-cell title="申报时间"
                    v-model="detail.CreateByDate" />
          <van-cell title="课程描述"
                    v-model="detail.DeclareSujectDescribe" />
        </van-cell-group>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    detailModel: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  name: 'DeclareDetail',
  components: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    //关闭当前弹框
    closeCur () {
      this.$emit('closeDetail');
    }
  },
}
</script>
<style lang="less" scoped>
.detail-con {
  margin-top: 110px;
}
.van-cell-group {
  margin-top: 20px;
  background: #f9f9f9;
  .van-cell {
    margin-bottom: 15px;
    .van-cell__value {
      color: #666;
    }
  }
}
</style>
